import React, { useEffect, useState } from "react";
import LightGallery from "lightgallery/react";
// Plugins
import lgThumbnail from "lightgallery/plugins/thumbnail";
import lgZoom from "lightgallery/plugins/zoom";
// Styles
import "lightgallery/css/lightgallery.css";
import "lightgallery/css/lg-zoom.css";
import "lightgallery/css/lg-thumbnail.css";

import { getFileUrl } from "../../utils/GetAuthUser";
import { createSelector } from "@reduxjs/toolkit";
import { useDispatch, useSelector } from "react-redux";
import { getContestResultThunk as onGetContestResultThunk } from "../../slices/contest/thunk";

export const ArtistGallery = () => {
  const fileUrl = getFileUrl();
  const dispatch = useDispatch();
  const [images, setImages] = useState([]);
  // Selector for contest state
  const selectContestState = (state) => state.contest;
  const contestSelector = createSelector(selectContestState, (contest) => ({
    isLoading: contest.isLoading,
    contestResult: contest.contestResult,
  }));
  const { contestResult } = useSelector(contestSelector);

  useEffect(() => {
    dispatch(onGetContestResultThunk({ statusCode: 0 }));
  }, [dispatch]);

  useEffect(() => {
    if (Array.isArray(contestResult) && contestResult.length > 0) {
      const imageArray = contestResult.map((item, index) => ({
        id: item.id || index + 1,
        image: item.resultImage
          ? `${fileUrl}/${item.resultImage}`
          : `${fileUrl}/default.jpg`,
      }));
      setImages(imageArray);
    } else {
      setImages([]);
    }
  }, [contestResult, fileUrl]);

  return (
    <div className="w-full">
      <LightGallery
        speed={500}
        plugins={[lgThumbnail, lgZoom]}
        elementClassNames="columns-1 xs:columns-2 md:columns-3 lg:columns-4  gap-4"
      >
        {images.map((item) => (
          <a key={item.id} href={item.image} className="mb-4 block">
            <img
              src={item.image}
              alt="Result"
              className="w-full h-auto rounded-lg"
            />
          </a>
        ))}
      </LightGallery>
    </div>
  );
};
